import Vue from "vue";

//helper app
import "./Components/Helpers/HelperComponent";
import InputTag from "vue-input-tag";

import AppCookie from "../core/helpers/cookies/AppCookies";
window.AppCookie = AppCookie;

/**
 * all component of GUD
 */
Vue.component("personal-information", (resolve) => {
    import("./Components/Views/Auth/PersonalInformation").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("updates-notifier-configure", (resolve) => {
    import("./Components/Views/UpdatesNotifier/configure").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("image-generator-configure", (resolve) => {
    import("./Components/Views/ImageGenerator/admin/configure").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("image-generator-dashboard", (resolve) => {
    import("./Components/Views/ImageGenerator/menu-link/dashboard").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("image-generator-error", (resolve) => {
    import("./Components/Views/ImageGenerator/menu-link/error").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("custom-values-initiator", (resolve) => {
    import("./Components/Views/CustomValueInitiator/configure").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("sop-configure", (resolve) => {
    import("./Components/Views/SOP/admin/configure").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("standard-operating-procedure", (resolve) => {
    import("./Components/Views/SOP/client/index").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("new-sop", (resolve) => {
    import("./Components/Views/SOP/client/newSOP").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("edit-sop", (resolve) => {
    import("./Components/Views/SOP/client/editSOP").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("copy-sop", (resolve) => {
    import("./Components/Views/SOP/client/copySOP").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("sop-detail", (resolve) => {
    import("./Components/Views/SOP/client/detail").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("sop-folder", (resolve) => {
    import("./Components/Views/SOP/client/folderDetail").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("sop-shared", (resolve) => {
    import("./Components/Views/SOP/shared/sopDetail").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("error", (resolve) => {
    import("./Components/Views/SOP/client/error").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("task-module", (resolve) => {
    import("./Components/Views/tasks/index").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("task-list", (resolve) => {
    import("./Components/Views/tasks/tasklists").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("project-details", (resolve) => {
    import("./Components/Views/tasks/projectDetails").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("procedure", (resolve) => {
    import("./Components/Views/tasks/procedure/procedure").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("task-template", (resolve) => {
    import("./Components/Views/tasks/taskTemplate").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("avatars-group", (resolve) => {
    import("./Components/Views/tasks/components/AvatarsGroup").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});


Vue.component("request-setup", (resolve, _) => ({
    component: import(
        "./Components/Views/tasks/components/requestComponent/requestSetup"
    ).then((AsyncComponent) => resolve(AsyncComponent.default)),
    loading: {
        template:
            "<div style='height: calc(100vh - calc(68px + 2rem));'> <app-pre-loader  wrapper-class='h-100' /> </div>",
    },
    //   error: ErrorComponent,
    // The error component will be displayed if a timeout is
    // provided and exceeded. Default: Infinity.
    delay: 0,
}));

Vue.component("request-setup-form-builder", (resolve, _) => ({
    component: import(
        "./Components/Views/tasks/components/requestComponent/requestFormBuilder"
    ).then((AsyncComponent) => resolve(AsyncComponent.default)),
    loading: {
        template:
            "<div style='height: calc(100vh - calc(68px + 2rem));'> <app-pre-loader  wrapper-class='h-100' /> </div>",
    },
    //   error: ErrorComponent,
    // The error component will be displayed if a timeout is
    // provided and exceeded. Default: Infinity.
    delay: 0,
}));
Vue.component("request-setup-categories", (resolve, _) => ({
    component: import(
        "./Components/Views/tasks/components/requestComponent/requestCategories"
    ).then((AsyncComponent) => resolve(AsyncComponent.default)),
    loading: {
        template:
            "<div style='height: calc(100vh - calc(68px + 2rem));'> <app-pre-loader  wrapper-class='h-100' /> </div>",
    },
    //   error: ErrorComponent,
    // The error component will be displayed if a timeout is
    // provided and exceeded. Default: Infinity.
    delay: 0,
}));

Vue.component("list-view", (resolve, _) => ({
    component: import(
        "./Components/Views/tasks/components/listView"
    ).then((AsyncComponent) => resolve(AsyncComponent.default)),
    loading: {
        template:
            "<div id='pre-loader' style='height: calc(100vh - calc(68px + 2rem));'> <app-pre-loader  wrapper-class='h-100' /> </div>",
    },
    //   error: ErrorComponent,
    // The error component will be displayed if a timeout is
    // provided and exceeded. Default: Infinity.
    delay: 0,
}));

Vue.component("board-view", (resolve, _) => ({
    component: import(
        "./Components/Views/tasks/components/boardView"
    ).then((AsyncComponent) => resolve(AsyncComponent.default)),
    loading: {
        template:
            "<div id='pre-loader' style='height: calc(100vh - calc(68px + 2rem));'> <app-pre-loader  wrapper-class='h-100' /> </div>",
    },
    //   error: ErrorComponent,
    // The error component will be displayed if a timeout is
    // provided and exceeded. Default: Infinity.
    delay: 0,
}));


Vue.component("extension-view", (resolve, _) => ({
    component: import(
        "./Components/Views/tasks/components/extensionview"
    ).then((AsyncComponent) => resolve(AsyncComponent.default)),
    loading: {
        template:
            "<div style='height: calc(100vh - calc(68px + 2rem));'> <app-pre-loader  wrapper-class='h-100' /> </div>",
    },
    //   error: ErrorComponent,
    // The error component will be displayed if a timeout is
    // provided and exceeded. Default: Infinity.
    delay: 0,
}));

Vue.component("request-view", (resolve, _) => ({
    component: import(
        "./Components/Views/tasks/components/requestview"
    ).then((AsyncComponent) => resolve(AsyncComponent.default)),
    loading: {
        template:
            "<div style='height: calc(100vh - calc(68px + 2rem));'> <app-pre-loader  wrapper-class='h-100' /> </div>",
    },
    //   error: ErrorComponent,
    // The error component will be displayed if a timeout is
    // provided and exceeded. Default: Infinity.
    delay: 0,
}));


Vue.component("project-dashboard", (resolve, _) => ({
    component: import(
        "./Components/Views/tasks/components/dashboard"
    ).then((AsyncComponent) => resolve(AsyncComponent.default)),
    loading: {
        template:
            "<div style='height: calc(100vh - calc(68px + 2rem));'> <app-pre-loader  wrapper-class='h-100' /> </div>",
    },
    //   error: ErrorComponent,
    // The error component will be displayed if a timeout is
    // provided and exceeded. Default: Infinity.
    delay: 0,
}));

Vue.component("project-time", (resolve, _) => ({
    component: import("./Components/Views/tasks/components/time").then((AsyncComponent) =>
        resolve(AsyncComponent.default)
    ),
    loading: {
        template:
            "<div style='height: calc(100vh - calc(68px + 2rem));'> <app-pre-loader  wrapper-class='h-100' /> </div>",
    },
    //   error: ErrorComponent,
    // The error component will be displayed if a timeout is
    // provided and exceeded. Default: Infinity.
    delay: 0,
}));

Vue.component("project-files", (resolve, _) => ({
    component: import("./Components/Views/tasks/components/files").then((AsyncComponent) =>
        resolve(AsyncComponent.default)
    ),
    loading: {
        template:
            "<div style='height: calc(100vh - calc(68px + 2rem));'> <app-pre-loader  wrapper-class='h-100' /> </div>",
    },
    //   error: ErrorComponent,
    // The error component will be displayed if a timeout is
    // provided and exceeded. Default: Infinity.
    delay: 0,
}));

Vue.component("project-insight", (resolve) => {
    import("./Components/Views/tasks/components/projectInsightt").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("project-about", (resolve) => {
    import("./Components/Views/tasks/components/projectAboutt").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("summary-component", (resolve) => {
    import("./Components/Views/tasks/components/DashboardComponents/summary.vue").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});

Vue.component("activity-component", (resolve) => {
    import("./Components/Views/tasks/components/DashboardComponents/activity.vue").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});

Vue.component("read-component", (resolve) => {
    import("./Components/Views/tasks/components/DashboardComponents/read.vue").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});
Vue.component("unread-component", (resolve) => {
    import("./Components/Views/tasks/components/DashboardComponents/unread.vue").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});

Vue.component("settings", (resolve, _) => ({
    component: import(
        "./Components/Views/tasks/components/settings.vue"
    ).then((AsyncComponent) => resolve(AsyncComponent.default)),
    loading: {
        template:
            "<div style='height: calc(100vh - calc(68px + 2rem));'> <app-pre-loader  wrapper-class='h-100' /> </div>",
    },
    delay: 0,
}));

// Vue.component("settings", (resolve) => {
//   import("./Components/Views/tasks/components/settings.vue").then((AsyncComponent) => {
//     resolve(AsyncComponent.default);
//   });
// });

Vue.component("general-component", (resolve) => {
    import("./Components/Views/tasks/components/SettingComponents/general.vue").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});

Vue.component("notification-component", (resolve) => {
    import("./Components/Views/tasks/components/SettingComponents/notifications.vue").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});


Vue.component("slack-setup", (resolve) => {
    import("./Components/Views/tasks/components/SettingComponents/slackSetup.vue").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});


//custom starters here

Vue.component("custom-starter", (resolve) => {
    import("./Components/Views/CustomStarter/Index").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

//for apps status cherker pro 

Vue.component("status-master", (resolve) => {
    import("./Components/Views/StatusMaster/index").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
})

//components for knowledge base

Vue.component("knowledge-base", (resolve) => {
    import("./Components/Views/KnowledgeBase/Index").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
})

Vue.component("knowledge-base-chat-bot", (resolve) => {
    import("./Components/Views/KnowledgeBase/ChatBot").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
})


//components for livechat 

Vue.component("livechat-module", (resolve) => {
    import("./Components/Views/LiveChat/Index").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
})

Vue.component("livechat-setup", (resolve) => {
    import("./Components/Views/LiveChat/Setup").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
})



Vue.component("knowledge-base-create", (resolve) => {
    import("./Components/Views/KnowledgeBase/Create").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
})

Vue.component("custom-icon", (resolve) => {
    import("./Components/Views/KnowledgeBase/Components/CustomIcon").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
})

Vue.component("knowledge-base-agency", (resolve) => {
    import("./Components/Views/KnowledgeBase/AgencyIndex").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
})


Vue.component("knowledge-base-category", (resolve) => {
    import("./Components/Views/KnowledgeBase/Categories").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
})


Vue.component("knowledge-base-search", (resolve) => {
    import("./Components/Views/KnowledgeBase/SearchArticles").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
})


Vue.component("knowledge-base-category-preview", (resolve) => {
    import("./Components/Views/KnowledgeBase/CategoryPreview").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
})

Vue.component("knowledge-base-article-preview", (resolve) => {
    import("./Components/Views/KnowledgeBase/ArticlePreview").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
})


Vue.component("link-tree-settigns", (resolve) => {
    import("./Components/Views/LinkTree/Settigns").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});


Vue.component("link-tree-configure", (resolve) => {
    import("./Components/Views/LinkTree/configure").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("link-tree", (resolve) => {
    import("./Components/Views/LinkTree/Index").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});


Vue.component("link-tree-preview", (resolve) => {
    import("./Components/Views/LinkTree/preview").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});





Vue.component("custom-starter-customize", (resolve) => {
    import("./Components/Views/CustomStarter/Customize").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});


Vue.component("custom-starter-preview", (resolve) => {
    import("./Components/Views/CustomStarter/Preview").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});


Vue.component("funnel-template", (resolve) => {
    import("./Components/Views/FunnelTemplates/templates").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("all-templates", (resolve) => {
    import("./Components/Views/FunnelTemplates/funnelTemplates.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("onboarding", (resolve) => {
    import("./Components/Views/onBoarding/templates").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("ghl-customization", (resolve) => {
    import("./Components/Views/ghlCustomization/templates").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

// Vue.component("login-clone", (resolve) => {
//     import("./Components/Views/ghlCustomization/components/loginClone.vue").then((AsyncComponent) => {
//         resolve(AsyncComponent.default);
//     });
// });

// Vue.component("ghl-settings", (resolve) => {
//   import("./Components/Views/ghlCustomization/customization/settings.vue").then((AsyncComponent) => {
//     resolve(AsyncComponent.default);
//   });
// });

Vue.component("ghl-layout", (resolve) => {
    import("./Components/Views/ghlCustomization/customization/layouts").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});


Vue.component("onboarding-dashboard", (resolve) => {
    import("./Components/Views/onBoarding/dashboard/dashboard").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});


Vue.component("onboarding-editor", (resolve) => {
    import("./Components/Views/onBoarding/editor").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});


Vue.component("funnel-template-editor", (resolve) => {
    import("./Components/Views/FunnelTemplates/editor").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("funnel-grid-view", (resolve) => {
    import("./Components/Views/FunnelTemplates/components/funnelGridView").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});

Vue.component("password-change", (resolve) => {
    import("./Components/Views/Auth/PasswordChange").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("social-links", (resolve) => {
    import("./Components/Views/Auth/SocialLinks").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("stripe-customer-portal-link", (resolve) => {
    import("./Components/Views/Auth/StripeCustomerPortalLink").then((AsyncComponent) => {
        resolve(AsyncComponent);
    });
});
Vue.component("login", (resolve) => {
    import("./Components/Views/Auth/Login").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("register", (resolve) => {
    import("./Components/Views/Auth/Register").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
// /* webpackPrefetch: true */
Vue.component("password-reset", (resolve) => {
    import("./Components/Views/Auth/PasswordReset").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("reset-password", (resolve) => {
    import("./Components/Views/Auth/ResetPassword").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("registration", (resolve) => {
    import("./Components/Views/Auth/Registration").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("my-profile", (resolve) => {
    import("./Components/Views/Auth/Profile").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

// Settings
Vue.component("app-setting", (resolve) => {
    import("./Components/Views/Settings/Index").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("general-setting", (resolve) => {
    import("./Components/Views/Settings/GeneralSetting").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("email-notification", (resolve) => {
    import("./Components/Views/Settings/EmailNotification").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

// Vue.component("sms-setting", (resolve) => {
//   import("./Components/Views/Settings/SmsSetting").then((AsyncComponent) => {
//     resolve(AsyncComponent.default);
//   });
// });

Vue.component("customizations", (resolve) => {
    import("./Components/Views/Settings/customisation").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("wordpress-plugin", (resolve) => {
    import("./Components/Views/wordpress_plugin/wordpress").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("agency-script", (resolve) => {
    import("./Components/Views/Settings/agencyScript").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("agency-api-key", (resolve) => {
    import("./Components/Views/Settings/AgencyApiKey").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

// Vue.component("google-re-captcha-setting", (resolve) => {
//   import("./Components/Views/Settings/GoogleRecaptchaSetting").then(
//     (AsyncComponent) => {
//       resolve(AsyncComponent.default);
//     }
//   );
// });
Vue.component("notification-settings", (resolve) => {
    import("./Components/Views/Settings/Notification/Settings/Index").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});
Vue.component("database-template", (resolve) => {
    import("./Components/Views/Settings/Notification/Template/DatabaseTemplate").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});
Vue.component("mail-template", (resolve) => {
    import("./Components/Views/Settings/Notification/Template/MailTemplate").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});
Vue.component("payment-method", (resolve) => {
    import("./Components/Views/Settings/PaymentMethod/PaymentMethod").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});

Vue.component("get-started", (resolve) => {
    import("./Components/Views/Settings/GetStarted/GetStarted").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});


Vue.component("customisation", (resolve) => {
    import("./Components/Views/Settings/customisation").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("payment-method-create-edit-modal", (resolve) => {
    import("./Components/Views/Settings/PaymentMethod/PaymentMethodCreateEditModal").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});

// User and Roles
Vue.component("user-roles", (resolve) => {
    import("./Components/Views/UserRoles/Index").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("group-of-users", (resolve) => {
    import("./Components/Views/UserRoles/Roles/GroupOfUsers").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

// Layouts
Vue.component("app-top-bar", (resolve) => {
    import("./Components/Views/Layouts/Nabar").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
}); 


Vue.component("whitelabel-top-bar", (resolve) => {
    import("./Components/Views/Layouts/WhitelabelNavBar").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
}); 


Vue.component("app-custom-sidebar", (resolve) => {
    import("./Components/Views/Layouts/CustomSideBar").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});


Vue.component("app-custom-topbar", (resolve) => {
    import("./Components/Views/Layouts/TopHeader.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});   




//Vue.component('app-sidebar', (resolve) => {
//   import('./Components/Views/Layouts/Sidebar').then((AsyncComponent) => {
//       resolve(AsyncComponent.default);
//     })});

// notifications
Vue.component("all-notification", (resolve) => {
    import("./Components/Views/Auth/Notification").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("re-captcha", (resolve) => {
    import("./Components/Views/Auth/ReCaptcha").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("custom-search-settings", (resolve) => {
    import("./Components/Views/customSearch/settings").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("payment-view", (resolve) => {
    import("./Components/Views/Demo/Pages/PaymentMethodView").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

//Custom Table
Vue.component("app-custom-tables", (resolve) => {
    import("./Components/Views/Settings/CustomTable/CustomTable").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("app-custom-table-modal", (resolve) => {
    import("./Components/Views/Settings/CustomTable/CustomTableModal").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});

// Dynamic table
Vue.component("app-custom-table-dynamic", (resolve) => {
    import("./Components/Views/Demo/CustomTable/DynamicPage").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

// customizer
Vue.component("customs", (resolve) => {
    import("./Components/Views/CustomValues/customs").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

//transfer services  
Vue.component("transfer-service", (resolve) => {
    import("./Components/Views/Dashboard/Admin/ServicePackage/TransferServices.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});


Vue.component("custom-values", (resolve) => {
    import("./Components/Views/CustomValues/custom").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("webinarboss-configure", (resolve) => {
    import("./Components/Views/CustomValues/webinarboss/configure").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("webinarboss", (resolve) => {
    import("./Components/Views/CustomValues/webinarboss/index").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("webinarboss-setupaccount", (resolve) => {
    import("./Components/Views/CustomValues/webinarboss/setupaccount").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("webinarboss-schedule-meeting", (resolve) => {
    import("./Components/Views/CustomValues/webinarboss/scheduleMeeting").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("webinarboss-schedule-webinar", (resolve) => {
    import("./Components/Views/CustomValues/webinarboss/scheduleWebinar").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("webinarboss-cancel-meeting", (resolve) => {
    import("./Components/Views/CustomValues/webinarboss/cancelMeeting").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("webinarboss-cancel-webinar", (resolve) => {
    import("./Components/Views/CustomValues/webinarboss/cancelWebinar").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});


Vue.component("livemeeting", (resolve) => {
    import("./Components/Views/CustomValues/webinarboss/livemeeting").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("livewebinar", (resolve) => {
    import("./Components/Views/CustomValues/webinarboss/livewebinar").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("meeting-live-set-values", (resolve) => {
    import("./Components/Views/CustomValues/webinarboss/meetingLiveSetValues").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("webinar-live-set-values", (resolve) => {
    import("./Components/Views/CustomValues/webinarboss/webinarLiveSetValues").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("livemeeting-url-overrides-page", (resolve) => {
    import("./Components/Views/CustomValues/webinarboss/livemeetingUrlOverridesPage").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("livewebinar-url-overrides-page", (resolve) => {
    import("./Components/Views/CustomValues/webinarboss/livewebinarUrlOverridesPage").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("copy-account", (resolve) => {
    import("./Components/Views/CustomValues/copyAccount").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("page2", (resolve) => {
    import("./Components/Views/CustomValues/pages/page2").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("page1", (resolve) => {
    import("./Components/Views/CustomValues/pages/page1/page1").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("new-accounts", (resolve) => {
    import("./Components/Views/Accounts/new_design/accounts").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("accounts", (resolve) => {
    import("./Components/Views/Accounts/accounts").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("buttons-view", (resolve) => {
    import("./Components/Views/Buttons/buttons").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("operations", (resolve) => {
    import("./Components/Views/CustomValues/operations").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("reporting", (resolve) => {
    import("./Components/Views/Reporting/reporting").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("account-grid-view", (resolve) => {
    import("./Components/Views/Accounts/accountGridView").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

//button page
Vue.component("button-page", (resolve) => {
    import("./Components/Views/ButtonPage/buttonPage").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

//bulk upload page
Vue.component("bulk-upload", (resolve) => {
    import("./Components/Views/Settings/BulkUpload/Upload").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("contact_upload", (resolve) => {
    import("./Components/Views/Settings/BulkUpload/ContactUploadForm").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});
Vue.component("import_field", (resolve) => {
    import("./Components/Views/Settings/BulkUpload/ImportField").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

//admin affiliate dashboard
Vue.component("dashboard-admin-affiliate", (resolve) => {
    import("./Components/Views/Dashboard/Admin/Affiliate").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

//user affiliate dashboard
Vue.component("dashboard-user-affiliate", (resolve) => {
    import("./Components/Views/Dashboard/User/Affiliate").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

// Vue.component("dashboard-user-affiliate", (resolve) => {
//   import("./Components/Views/Dashboard/User/Affiliate").then((AsyncComponent) => {
//     resolve(AsyncComponent.default);
//   });
// });

//affiliate registration
Vue.component("affiliate-register", (resolve) => {
    import("./Components/Views/Auth/AffiliateRegistration").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

//api interface
Vue.component("api-interface", (resolve) => {
    import("./Components/Views/APIInterface/ApiInterface.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

//invoice applet
Vue.component("invoice-applet", (resolve) => {
    import("./Components/Views/Applets/Invoice/Invoice.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

//qrcode applet
Vue.component("qrcode-applet", (resolve) => {
    import("./Components/Views/Applets/qrcode/qrCode.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

//faker applet
Vue.component("faker-applet", (resolve) => {
    import("./Components/Views/Applets/Faker/Faker.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("faker_all-applet", (resolve) => {
    import("./Components/Views/Applets/Faker/FakerAll.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

//dnshelper applet
Vue.component("dnshelper-applet", (resolve) => {
    import("./Components/Views/Applets/dnshelper/dnsHelper.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

//spinner applet
Vue.component("spinner-applet", (resolve) => {
    import("./Components/Views/Applets/Spinner/Spinner.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
//slack webhook page
Vue.component("slack-channel", (resolve) => {
    import("./Components/Views/Settings/SlackChannel/Slack").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

//api links page
Vue.component(
    "api-links",
    require("./Components/Views/Settings/links/LinksTable").default
);
Vue.component(
    "app-link-modal",
    require("./Components/Views/Settings/links/LinksTableModal").default
);

//api signature page
Vue.component("list-document", (resolve) => {
    import("./Components/Views/Document/ListDocument").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("list-document-instances", (resolve) => {
    import("./Components/Views/Document/DocumentInstances").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("add-document", (resolve) => {
    import("./Components/Views/Document/AddDocument").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("custom-document", (resolve) => {
    import("./Components/Views/Document/CustomDocument").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component(
    "api-signature",
    require("./Components/Views/Document/esignature/Signature").default
);
Vue.component("api-sign", require("./Components/Views/Document/esignature/Sign").default);

//business page
Vue.component(
    "business",
    require("./Components/Views/Settings/Business/Reviews").default
);

Vue.component(
    "ReviewList",
    require("./Components/Views/Settings/Business/components/ReviewList.vue").default
);

//event Triggers
// Vue.component(
//     "event-triggers",
//     (resolve) => {
//   import("./Components/Views/EventTriggers/EventTrigger.vue").then((AsyncComponent) => {
//       resolve(AsyncComponent.default);
//     })}
// );

Vue.component("event-triggers", (resolve) => {
    import("./Components/Views/EventTriggers/EventTriggerListing.vue").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});

//googlesheet applet
Vue.component("googlesheet-applet", (resolve) => {
    import("./Components/Views/Applets/GoogleSheet/GoogleSheet.vue").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});

//service package
Vue.component("service-package", (resolve) => {
    import(
        "./Components/Views/Dashboard/Admin/ServicePackage/ServicePackageTable.vue"
    ).then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("service-package-show", (resolve) => {
    import("./Components/Views/Dashboard/Admin/ServicePackage/ServicePackageShow.vue").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});

//user service
Vue.component("user-service", (resolve) => {
    import("./Components/Views/Dashboard/Admin/UserServices/UserServicesTable.vue").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});

//app service
Vue.component("app-service", (resolve) => {
    import("./Components/Views/Dashboard/Admin/AppServices/ServicesTable.vue").then(
        (AsyncComponent) => {
            resolve(AsyncComponent.default);
        }
    );
});
Vue.component("input-tag", InputTag);
Vue.component("app-errors", (resolve) => {
    import("./Components/Views/Error/error.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component("app-hlprivacy", (resolve) => {
    import("./Components/Views/Privacy/Privacy.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

//admin settings
Vue.component("app-admin-settings", (resolve) => {
    import("./Components/Views/Settings/AdminSettings").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("external-project-details", (resolve) => {
    import("./Components/Views/tasks/clientRequest/external").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("tasks-setup", (resolve) => {
    import("./Components/Views/tasks/components/TaskFormComponent/TaskSetup").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("email-setup", (resolve) => {
    import("./Components/Views/tasks/components/Emails/Setup").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("calendar-task-view", (resolve) => {
    import("./Components/Views/tasks/components/Calendar/Calendar").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
})

Vue.component("table-view", (resolve) => {
    import("./Components/Views/tasks/components/TableView").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
})

//request system components

Vue.component("task-form", (resolve, _) => ({
    component: import(
        "./Components/Views/tasks/components/TaskFormComponent/Task"
    ).then((AsyncComponent) => resolve(AsyncComponent.default)),
    loading: {
        template:
            "<div style='height: calc(100vh - calc(68px + 2rem));'> <app-pre-loader  wrapper-class='h-100' /> </div>",
    },
    delay: 0,
}));


Vue.component("request-table-view", (resolve, _) => ({
    component: import(
        "./Components/Views/tasks/clientRequest/components/tableView"
    ).then((AsyncComponent) => resolve(AsyncComponent.default)),
    loading: {
        template:
            "<div style='height: calc(100vh - calc(68px + 2rem));'> <app-pre-loader  wrapper-class='h-100' /> </div>",
    },
    //   error: ErrorComponent,
    // The error component will be displayed if a timeout is
    // provided and exceeded. Default: Infinity.
    delay: 0,
}));

//custom workflow
Vue.component("work-flow-preseelcted", (resolve) => {
    import('./Components/Views/WorkflowApp/PreseelctedApps').then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
});
Vue.component("custom-work-flows-app-menu-link", (resolve) => {
    import('./Components/Views/WorkflowApp/CustomWorkflowsAppMenuLink').then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
});
Vue.component("custom-work-flows-app-install", (resolve) => {
    import('./Components/Views/WorkflowApp/CustomWorkflowsAppInstall').then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
});

Vue.component("custom-work-flow-subaccount-redirect", (resolve) => {
    import('./Components/Views/WorkflowApp/CustomWorkflowSubaccountRedirect').then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
});

Vue.component("dashboard-custom-work-flows", (resolve) => {
    import("./Components/Views/WorkflowApp/UserApplication").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("dashboard-custom-work-flows-ghlp", (resolve) => {
    import("./Components/Views/WorkflowApp/GHLPluginsUserApplication").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("app-scopes", (resolve) => {
    import("./Components/Views/WorkflowApp/AppScopes.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("app-chips", (resolve) => {
    import("./Components/Views/WorkflowApp/AppChips.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("dashboard-custom-work-flows-ghlp-manager", (resolve) => {
    import("./Components/Views/WorkflowApp/GHLPluginsUserApplicationManager").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

// allservice display
Vue.component("dashboard-custom-allservices-ghlp-manager", (resolve) => {
    import("./Components/Views/WorkflowApp/GHLPluginsAllSercesManager").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

// allservice user display
Vue.component("dashboard-custom-user-allservices-ghlp-manager", (resolve) => {
    import("./Components/Views/WorkflowApp/GHLPluginsAllServices").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});




Vue.component("freebies-admin", (resolve) => {
    import('./Components/Views/Freebies/Admin').then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
});
Vue.component("app-component-indexform", (resolve) => {
    import('./Components/Views/LocationCreator/LocationCreatorIndexForm.vue').then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
});
Vue.component("app-component-location-action", (resolve) => {
    import('./Components/Views/LocationCreator/LocationCreatorAddEditLocation.vue').then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
});
Vue.component("freebies-public", (resolve) => {
    import('./Components/Views/Freebies/Public').then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
});
Vue.component("freebies-script", (resolve) => {
    import('./Components/Views/Freebies/Admin/script.vue').then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
});

Vue.component("link-tree-form", (resolve) => {
    import("./Components/Views/LinkTree/Form").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

/* Vue.component("app-component-location-action", (resolve) => {
    import("./Components/Views/LocationCreator/LocationCreatorAddEditLocation").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
}); */

Vue.component("workflow-entities", (resolve) => {
    import("./Components/Views/WorkflowAppEntity/index").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component("custom-modal", (resolve) => {
    import("./Components/Views/WorkflowAppEntity/CustomModal").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

Vue.component('workflow-app-doc', (resolve) => {
    import("./Components/Views/WorkflowAppEntity/EntityDoc.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

// Vue.component("login-clone", (resolve) => {
//     import("./Components/Views/ghlCustomization/components/loginClone.vue").then((AsyncComponent) => {
//         resolve(AsyncComponent.default);
//     });
// });
Vue.component("loader-clone", (resolve) => {
    import("./Components/Views/ghlCustomization/components/loaderClone/LoaderClone.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component('medical-apps', (resolve) => {
    import("./Components/Views/MedicalApps/index.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});
Vue.component('single-task', (resolve) => {
    import("./Components/Views/tasks/components/singleFileDetails.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

//custom
Vue.component("workflowapp-custommenulink", (resolve) => {
    import('./Components/Views/WorkflowAppCustomMenuLink/App.vue').then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
});

Vue.component("workflowapp-custommenulink-sub", (resolve) => {
    import('./Components/Views/WorkflowAppCustomMenuLink/components/AppDetailSub.vue').then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
});

Vue.component("app-speed-to-lead", (resolve) => {
    import('./Components/Views/Speed-to-lead/home.vue').then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
});
Vue.component("app-speed-to-lead-client", (resolve) => {
    import('./Components/Views/Speed-to-lead/client.vue').then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
});
Vue.component("app-speed-to-lead-index", (resolve) => {
    import('./Components/Views/Speed-to-lead/index.vue').then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
});
Vue.component("speed-to-lead", (resolve) => {
    import('./Components/Views/Speed-to-lead/spead.vue').then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
});
Vue.component("modal-admin", (resolve) => {
    import('./Components/Views/UrlsubAccountModal/urlSubAccountModal.vue').then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
});
Vue.component("video-link", (resolve) => {
    import('../core/components/Videos/VideoLink.vue').then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    })
});

Vue.component("webhook-payload-samples", (resolve) => {
    import("./Components/Views/Settings/WebhookPayloadSamples.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

//changelog services  
Vue.component("workflow-changelog", (resolve) => {
    import("./Components/Views/WorkflowappChangelog/src/views/AdminView.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});

//changelog for users

Vue.component("workflow-changelog-user", (resolve) => {
    import("./Components/Views/WorkflowappChangelog/src/views/UserView.vue").then((AsyncComponent) => {
        resolve(AsyncComponent.default);
    });
});